import {
  Children,
  Fragment,
  createContext,
  useContext,
  useId,
  useMemo,
} from 'react'

import { useDisclosure } from '../../hooks'
import type { ExpandableTextContextState, ExpandableTextProps } from './types'

const ExpandableTextContext = createContext<ExpandableTextContextState>(
  {} as ExpandableTextContextState,
)

export const useExpandableTextContext = () => useContext(ExpandableTextContext)

export const ExpandableText = ({
  children,
  defaultExpanded = false,
  id,
  className,
}: ExpandableTextProps) => {
  const { isOpen, onToggle } = useDisclosure({
    defaultOpen: defaultExpanded,
  })
  const textId = id ?? useId()

  const context = useMemo(
    () => ({
      isExpanded: isOpen,
      textId,
      onToggle,
    }),
    [isOpen, onToggle, textId],
  )

  const resolvedClassName =
    typeof className === 'function' ? className(context) : className

  const renderedChildren =
    typeof children === 'function' ? children(context) : children

  return (
    <ExpandableTextContext.Provider value={context}>
      <div className={resolvedClassName}>{renderedChildren}</div>
    </ExpandableTextContext.Provider>
  )
}
